
import { mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('topics');

export const getTopicById = mount((localState, topicId) => {
  return localState.byId[topicId];
});

export const getTopics = mount((localState, categoryId, rootState) => {
  if(!categoryId) {
    return [];
  }

  return Object
    .keys(localState.byId)
    .map(topicId => getTopicById(rootState, topicId))
    .filter(topic => topic.categoryId == categoryId)
    .sort((topic1, topic2) => topic1.title.localeCompare(topic2.title));
});



/** WEBPACK FOOTER **
 ** ./src/members/state/topics/selectors.js
 **/